import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a19fc26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "租户", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "设备总数"),
  /*#__PURE__*/_createElementVNode("p", null, "在线设备总数"),
  /*#__PURE__*/_createElementVNode("p", null, "离线设备总数"),
  /*#__PURE__*/_createElementVNode("p", null, "在线率"),
  /*#__PURE__*/_createElementVNode("p", null, "离线率")
], -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "租户", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "设备名称"),
  /*#__PURE__*/_createElementVNode("p", null, "告警场景"),
  /*#__PURE__*/_createElementVNode("p", null, "告警级别"),
  /*#__PURE__*/_createElementVNode("p", null, "告警时间")
], -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "设备", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "设备发送报文数量")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "每天", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "最近一周", -1))
const _hoisted_13 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM, REPORT_EXECUTE_FREQUENCY_TYPE } from '@/common'
import Text from '@/components/text'
import { useTenantStore } from '@/stores/tenant'
import {
  addReportConfig,
  queryReportConfigDetail,
  updateReportConfig,
} from '@/api'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'report-onfig-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const tenantStore = useTenantStore()

tenantStore.queryTenant()

const $emit = __emit
const props = __props

const reportTypeOps = [
  {
    label: '设备指标汇总表',
    value: 'device-index-summary-table',
  },
  {
    label: '设备发送报文汇总表',
    value: 'device-send-datagram-table',
  },
  {
    label: '设备状态表',
    value: 'device-status-summary-table',
  },
  {
    label:'设备告警表',
    value:'device-alarm-record-table'
  }
]

const frequencyOps = [
  {
    label: '每天',
    value: REPORT_EXECUTE_FREQUENCY_TYPE.DAY,
  },
  {
    label: '每周',
    value: REPORT_EXECUTE_FREQUENCY_TYPE.WEEK,
  },
  {
    label: '每月',
    value: REPORT_EXECUTE_FREQUENCY_TYPE.MONTH,
  },
]

const weekMap = {
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周日',
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryDetail()
    }
  }
)

const formData = ref({
  reportCode: '',
  frequency: '',
  selectedDayOfWeek: '',
  selectedDayOfMonth: '',
  dailyTime: '',
  orgIdList: [],
})

const detailLoading = ref(false)
const queryDetail = async () => {
  if (!props.data.id) {
    return
  }
  const res: any = await queryReportConfigDetail({
    id: props.data.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const {
      frequency,
      selectedDayOfWeek,
      selectedDayOfMonth,
      dailyTime,
      orgIdList,
      reportCode,
    } = res.data

    let moDailyTime: any = ''
    if (dailyTime) {
      const str = moment().format('YYYY-MM-DD')
      moDailyTime = moment(str + ' ' + dailyTime).valueOf()
    }

    formData.value = {
      ...formData.value,
      frequency,
      selectedDayOfWeek,
      selectedDayOfMonth,
      dailyTime: moDailyTime,
      orgIdList,
      reportCode,
    }
  }
}

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
}

const rules: any = {
  reportCode: [{ required: true, message: '请选择' }],
  orgIdList: [{ required: true, message: '请选择', type: 'array' }],
  frequency: [{ required: true, message: '请选择' }],
  dailyTime: [{ required: true, message: '请选择' }],
  selectedDayOfWeek: [{ required: true, message: '请选择' }],
  selectedDayOfMonth: [{ required: true, message: '请选择' }],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()
const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const { dailyTime, ...p } = formData.value
      const fn = props.data.id ? updateReportConfig : addReportConfig
      loading.value = true
      const res: any = await fn({
        dataType: 'OPERATION',
        executeMethod: 'CYCLE',
        ...p,
        dailyTime: dailyTime ? moment(dailyTime).format('HH:mm') : '',
        reportName: getReportName(),
        id: props.data.id,
      }).finally(() => {
        loading.value = false
      })
      loading.value = false

      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: props.data.id ? '修改报表配置成功' : '新建报表成功',
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

const getReportName = () => {
  const { reportCode } = formData.value
  return reportTypeOps.filter((_: any) => _.value === reportCode)?.[0]?.label
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: props.data.id ? '编辑报表配置' : '新建报表配置',
    size: "480px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_13, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "报表名称",
              prop: "reportCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.reportCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.reportCode) = $event)),
                  class: "ws_select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reportTypeOps, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (
            [
              'device-index-summary-table',
              'device-send-datagram-table',
            ].includes(formData.value.reportCode)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_el_form_item, { label: "对象" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "字段" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.reportCode === 'device-alarm-record-table')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_form_item, { label: "对象" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "字段" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (formData.value.reportCode === 'device-status-summary-table')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_form_item, { label: "对象" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "字段" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "间隔" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "时间范围" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "租户范围",
              prop: "orgIdList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.orgIdList,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.orgIdList) = $event)),
                  class: "ws_select",
                  filterable: "",
                  multiple: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantStore).tenantList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.orgId,
                        label: item.orgName,
                        value: item.orgId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "time-box" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  class: "select",
                  prop: "frequency",
                  label: "执行方式"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.frequency,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.frequency) = $event)),
                      class: "ws_select",
                      placeholder: "请选择执行方式"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(frequencyOps, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (formData.value.frequency === _unref(REPORT_EXECUTE_FREQUENCY_TYPE).WEEK)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      class: "select",
                      prop: "selectedDayOfWeek",
                      label: "",
                      "label-width": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "ws_select",
                          modelValue: formData.value.selectedDayOfWeek,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.selectedDayOfWeek) = $event)),
                          placeholder: "周几"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (item) => {
                              return _createVNode(_component_el_option, {
                                key: item,
                                label: weekMap[item],
                                value: item
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (formData.value.frequency === _unref(REPORT_EXECUTE_FREQUENCY_TYPE).MONTH)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      class: "select",
                      prop: "selectedDayOfMonth",
                      label: "",
                      "label-width": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.value.selectedDayOfMonth,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.selectedDayOfMonth) = $event)),
                          class: "ws_select",
                          placeholder: "第几天"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (item) => {
                              return _createVNode(_component_el_option, {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "time",
              prop: "dailyTime",
              label: "",
              "label-width": 80
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  modelValue: formData.value.dailyTime,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.dailyTime) = $event)),
                  format: "HH:mm",
                  placeholder: "请选择时间",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, detailLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})